<template>
<!-- Remember to include jQuery :) -->

  <div class="hello" style="text-align:right; ">
    <select v-model="filter" v-on:change="this.fetchData(1);" style="border-radius:5px; padding:3px; background:#333; border:1px solid #000; color:#fff;font-size:13px;">
      <option value="ALL">ALL</option>
      <option style="height:40px;" v-for="tier in this.$parent.tiers" :key="tier.tier" :value="tier.score">{{ tier.tier}}</option>
    </select>&nbsp;&nbsp;
                  <div class="tab-content">
                <!-- <router-view/> -->
                <div>



                    <div class="item_box" v-for="item in items">
                      <div class="item_box_title "><span  :style="'padding:1px 2px; font-size:11px;color:#fff;border-radius:4px;' + (item.gender == 1 ? 'background:#007bff;' : item.gender == 3 ? '' : 'background:#d92550;')" ><strong>{{ item.gender == 1 ? "남" : item.gender == 3 ? "" : "여" }}</strong></span> {{ item.name }}&nbsp;<span v-if="item.new" style="background:#ffcc00; color:#333; font-size:10px;font-weight:bold; padding:1px 2px; border-radius:4px;">{{ item.new }}</span><span style="color: #3cff00; padding: 2px 4px; border-radius: 4px; font-size:10px; font-weight:bold;">{{ item.tag}}</span></div>
                      <div class="item_box_item" style="position:relative;"><img :src="'https://avatar.useschool.co.kr/avatar/img/item/' + item.type + '/' + item.code + '.png'"><div style="position:absolute; left:3px; top:3px;"><span class="tier_tag" style=" color:#333; font-weight:bold; font-size:10px;  font-style: italic; padding:2px 4px; border-radius:10px;" v-bind:style="{backgroundColor: item.tier == 'EVENT' ? '#55ff19' : '#f0f0f0'}">{{ item.tier }}</span></div></div>
                      <div class="item_box_price_fame" v-if="item.price[0] && item.price[0].price != 0 ">{{item.price[0].price }} <span><img src="https://useschool.co.kr//UbestA/Ubesta2_new/img/buy_carat.png" style="width:20px;"></span> </div>
                      <div class="item_box_buy_fame" v-on:click="openItemDialog(item);" v-if="item.price[0].price != 0" data-toggle="modal" data-target="#exampleModal">구매</div>
					  <!-- Modal HTML embedded directly into document -->



                    <br>
                    <div style="clear: both"></div>
                    <!-- <div style="text-align: center; color: #fff; font-size: 14px; margin-top: 20px;">◀ 1 / 2 ▶</div> -->

                </div>
                					<div style="clear:both">&nbsp;</div>
                <div style="text-align:center; position:relative; top:00px; ">
                <router-link :to="'/shop/' + currentType + '/' + (+currentPage - 1)" v-if="currentPage > 1"><img src="https://bizstudy.useschool.co.kr/img/btn_prev.png" style="width:100px;" /></router-link>&nbsp;
                <router-link :to="'/shop/' + currentType + '/' + (+currentPage + 1)" v-if="items.length >= 8"><img src="https://bizstudy.useschool.co.kr/img/btn_next.png" style="width:100px;" /></router-link>
                </div>
              </div>
  </div>


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" >
    <div class="modal-content" style="background:#202020; color:#bcbcbc;">
      <div class="modal-header" style="border-bottom:1px solid #333; margin:10px 16px;">
        <h5 class="modal-title" id="exampleModalLabel">아이템 구매</h5>
        <button type="button" class="close" style="color:#fff;" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
	  <div style=text-align:center;>
	   <div style="border-radius: 10px; display:inline-block; padding:2px 14px;  text-align: center; font-size:18px; background:#ffb400; font-weight:bold;color:#333; margin-bottom:20px;  letter-spacing: -1.4px;">{{ modalDesc.item.name }}</div>
	   <div style="text-align:center;"><img :src="'//avatar.useschool.co.kr/avatar/img/item/' + modalDesc.item.type + '/' + modalDesc.item.code + '.png'" ></div>
        </div>

		  <div style="height:1px; background:#333333; margin-top: 8px;  "></div>
          <div style="height:1px; background:#111; margin-bottom: 8px;"></div>
		 <label v-for="payMethod in modalDesc.item.price" style="display:block; text-align:left;" v-bind:key="payMethod.id" >
    <input type="radio" :value="payMethod.id" v-model="modalDesc.buyPrice">
     &nbsp;<span :style="payMethod.period < 0 ? 'color: #ffb400; ' : ''" style="font-weight:bold;font-size:16px;" >{{ payMethod.price }}{{payMethod.type}} ({{ payMethod.period < 0 ? "무제한" : payMethod.period + "일"}})</span><br></label>

    <div style="height:1px; background:#333333; margin-top: 8px;"></div>
  <div style="height:1px; background:#111; margin-bottom: 8px;"></div>

	<div style="font-size: 14px; font-weight: normal; color: #fff; line-height: 16px;text-align:left;">{{ modalDesc.item.description }}<br><br>
		<span style="color: #00f6ff; font-weight: 600;">{{ modalDesc.item.skill }}</span>
</div>

      </div>
      <div class="modal-footer" style="border-top:1px solid #333;">
        <button type="button" class="btn btn-danger" data-dismiss="modal" :disabled="modalDesc.buyPrice == ''" @click="buyItem()">구매</button>
        <button type="button" class="btn btn-light" data-dismiss="modal">닫기</button>
      </div>
    </div>
  </div>
</div>
  </div>

</template>

<script>
import axios from 'axios';
export default {
  name: 'home',
  methods: {
    fetchData(type, page) {
      this.currentType = type;
      this.currentPage = page;
        axios.get(this.$parent.persistent.apiUrl + 'getItemList.php?type=' + type + '&page=' + parseInt(page) + '&uid=' + this.$parent.loginID + '&filter=' + this.filter)
        .then(response => {
            // console.log(response.data)
            this.items = response.data.items
        }).catch((error) => console.log(error));
    },
    openItemDialog(item){

      this.modalDesc.item = item;
    },
    buyItem(){
        axios.get(this.$parent.persistent.apiUrl + 'buyItem.php?priceId=' + this.modalDesc.buyPrice + '&uid=' + this.$parent.loginID)
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
              this.$parent.alert("구매 성공")
              this.$parent.fetchMyInfo()
            }
        }).catch((error) => console.log(error));
    },
    studentAutoComplete(e){
      if(this.cancelToken){
        this.cancelToken.cancel();
      }
      this.cancelToken = axios.CancelToken.source();
      axios.get(this.$parent.persistent.apiUrl + 'memberQuery.php?name=' + e.target.value, {cancelToken: this.cancelToken.token})
        .then(response => {
            this.cancelToken = null;
            // console.log(response.data)
            // this.items = response.data.items
            /*if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
              this.$parent.alert("구매 성공")
              this.$parent.fetchMyInfo()
            }*/
            this.studentSearchRes = response.data;
            console.log(response.data)
            this.$forceUpdate()
        }).catch((error) => console.log(error));
    },
    addSendTgt(displayName, intMember){
      axios.get(this.$parent.persistent.apiUrl + 'convertUUIDtoID.php?userUUID=' + intMember)
        .then(response => {
            if(response.data.id){
              this.sendTgt[response.data.id] = displayName;
              this.studentSearchRes = {}
              this.studentNameType = "";
            } else {
              this.$parent.alert("해당 사용자는 아바타몰에 접속한 이력이 없어 선물을 받을 수 없습니다.");
            }
            this.$forceUpdate()
        }).catch((error) => console.log(error));

    },
    removeTgt(id){
      delete this.sendTgt[id]
       this.$forceUpdate()
    },
    sendGift(){
      // execute
              axios.get(this.$parent.persistent.apiUrl + 'sendGift.php?priceId=' + this.modalDesc.buyPrice + '&uid=' + this.$parent.loginID + '&tgtuid=' + Object.keys(this.sendTgt).join(","))
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
              this.$parent.alert("선물 성공")
              this.$parent.fetchMyInfo()
            }
        }).catch((error) => console.log(error));
    }
},
  watch: {
    '$route.params': {
        handler(newValue) {
            const { type, page } = newValue

            this.fetchData(type, page)
        },
        immediate: true,
    },
    'filter': {
      handler(){
        this.fetchData(this.currentType, 1)
      }
    }
},
data(){
  return {
    items: [],
    modalDesc: {
      item: {},
      buyPrice: ""

    },
    alertModal: "",
    currentPage: 1,
    currentType: "weapon",
    studentNameType: "",
    studentSearchRes: {},
    cancelToken: null,
    sendTgt: {},
    filter: "ALL"
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
